import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { DepartmentForm } from 'components/Forms';
import { useStyles } from './styles';

const Department: FC<any> = observer(({ type }) => {
  const classes = useStyles();

  return (
    <Container maxWidth='xl' className={classes.container}>
      <DepartmentForm type={type} />
    </Container>
  );
});

export default Department;
